import { type EventData as BranchEventData } from './types.ts';

export function createBranchBannerActionATPayload(
  type: string,
  data: BranchEventData
) {
  return {
    type,
    campaign: data.journey_link_data?.campaign,
    journeyName: data.journey_link_data?.journey_name,
    journeyType: data.journey_link_data?.journey_type,
    openApp: data.journey_link_data?.openApp,
    schemaVersion: '1.0',
  };
}
